import { createAxiosInstance } from "./client";
import { msalInstance } from "./msalInstance";

const axiosInstance = createAxiosInstance(msalInstance);
const ENDPOINT = '/enterprise';

export async function getEnterpriseByUuid(uuid) {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}/${uuid}`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération d'une entreprise.");
  }
};

export async function getEnterprises() {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération des entreprises.");
  }
};

export async function updateEnterprise(uuid, data) {
  try {
    const response = await axiosInstance.put(`${ENDPOINT}/${uuid}`, data);
    return response.data.data;
  } catch (error) {
    console.error("Failed to update enterprise:", error);
    throw new Error("Erreur lors de l'édition d'une entreprise.");
  }
};

export async function addReview(uuidEnterprise, data) {
  try {
    const response = await axiosInstance.post(`${ENDPOINT}/${uuidEnterprise}/review`, data);
    return response.data.data;
  } catch (error) {
    console.error("Failed to add review:", error);
    throw new Error("Erreur lors de l'ajout d'une note.");
  }
};

export async function editReview(uuidEnterprise, uuidReview, data) {
  try {
    const response = await axiosInstance.put(`${ENDPOINT}/${uuidEnterprise}/review/${uuidReview}`, data);
    return response.data.data;
  } catch (error) {
    console.error("Failed to add review:", error);
    throw new Error("Erreur lors de l'ajout d'une note.");
  }
};

export async function deleteReview(uuidEnterprise, uuidReview) {
  try {
    const response = await axiosInstance.delete(`${ENDPOINT}/${uuidEnterprise}/review/${uuidReview}`);
    return response.data.data;
  } catch (error) {
    console.error("Failed to delete review:", error);
    throw new Error("Erreur lors de la suppression d'une note.");
  }
};
